<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">{{staffs?.id ? "Edit staff" : "Create staff"}}</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form role="form" [formGroup]="form">
    <div class="box-body">
      <div class="form-group col-sm-6 col-xs-12">
        <label for="first_name">First Name*</label>
        <input
          type="text"
          class="form-control"
          formControlName="first_name"
          placeholder="First Name"
          />
        @if (
          form.controls['first_name'].hasError('required') &&
          (isSubmitted || form.controls['first_name'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12">
        <label for="last_name">Last Name*</label>
        <input
          type="text"
          class="form-control"
          formControlName="last_name"
          placeholder="Last Name"
          />
        @if (
          form.controls['last_name'].hasError('required') &&
          (isSubmitted || form.controls['last_name'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12">
        <label for="email">Email*</label>
        <input
          type="email" [readonly]="staffs?.id ? true :false"
          class="form-control"
          formControlName="email"
          placeholder="Email"
          />
        @if (
          form.controls['email'].hasError('required') &&
          (isSubmitted || form.controls['email'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
        @if (
          form.controls['email'].hasError('pattern') &&
          (isSubmitted || form.controls['email'].touched)
          ) {
          <control-message
            message="This email is not valid."
          ></control-message>
        }
      </div>
      <div class="form-group col-sm-6 col-xs-12 p-0">
        <div class="col-sm-2 col-xs-4 pl-0">
          <label for="country_code">Code*</label>
          <select
            class="form-control"
            formControlName="country_code"
            placeholder="Country Code"
            >
            <option value="">Select</option>
            @for (item of countryCodes$ | async; track item) {
              <option [value]="item.dial_code">{{'(' +item.dial_code+') ' +item.name }}</option>
            }
          </select>
          @if (
            form.controls['country_code'].hasError('required') &&
            (isSubmitted || form.controls['country_code'].touched)
            ) {
            <control-message
              message="This field is required."
            ></control-message>
          }
        </div>
        <div class="col-sm-10 col-xs-8">
          <label for="mobileno">Mobile Number***</label>
          <input
            type="text"
            class="form-control"
            formControlName="mobileno"
            placeholder="Mobile Number"
            maxlength="10"
            />
        </div>
        @if (
          form.controls['mobileno'].hasError('required') &&
          (isSubmitted || form.controls['mobileno'].touched)
          ) {
          <control-message
            message="This field is required."
          ></control-message>
        }
        @if (
          form.controls['mobileno'].hasError('pattern') &&
          (isSubmitted || form.controls['mobileno'].touched)
          ) {
          <control-message
            message="This number is not valid."
          ></control-message>
        }
      </div>
      <div class="form-group d-flex flex-wrap gap-3  col-sm-6 col-xs-12">
        <div class=" flex-grow-1">
          <label for="user_type">User Type*</label>
          <select class="form-control" formControlName="user_type">
            <option value="valet_attendant">Valet Attendant</option>
            <option value="valet_supervisor">Valet Supervisor</option>
          </select>
          @if (
            form.controls['user_type'].hasError('required') &&
            (isSubmitted || form.controls['user_type'].touched)
            ) {
            <control-message
              message="This field is required."
            ></control-message>
          }
        </div>
        <!-- <div *ngIf="data.createGeneralStaff" class="">
        <label for="user_type">Parking Place</label>
        <select class="form-control" formControlName="parking_place_id">
          <option value="">Select</option>
          <option
            [value]="item.id"
            *ngFor="let item of parking_places$ | async; let i = index"
            >{{ item.title }}</option
            >
          </select>
          <control-message
              *ngIf="
                form.controls['parking_place_id'].hasError('required') &&
                (isSubmitted || form.controls['parking_place_id'].touched)
              "
            message="This field is required."
          ></control-message>
        </div> -->
      </div>

      <!-- <div class="form-group col-sm-6 col-xs-12">
      <label for="password">Password*</label>
      <input
        type="password"
        class="form-control"
        formControlName="password"
        />
      <control-message
            *ngIf="
              form.controls['password'].hasError('required') &&
              (isSubmitted || form.controls['password'].touched)
            "
        message="This field is required."
      ></control-message>
      <control-message
            *ngIf="
              form.controls['password'].hasError('minLength') &&
              (isSubmitted || form.controls['password'].touched)
            "
        message="Password is too short."
      ></control-message>
    </div> -->
    <div class="form-group col-sm-6 col-xs-12">
      <label for="shift_start_time">Shift Start Time*</label>
      <!-- <input type="text" placeholder="24hr format" class="form-control" aria-label="24hr format" [ngxTimepicker]="fullTime" [format]="24"  readonly> -->
      <!-- <ngx-material-timepicker #fullTime></ngx-material-timepicker> -->

      <!-- <input
      type="text"
      class="form-control"
      formControlName="shift_start_time"
      placeholder="00:00:00"
      /> -->
      <timepicker [showMeridian]="false" formControlName="shift_start_time"></timepicker>
      @if (
        form.controls['shift_start_time'].hasError('required') &&
        (isSubmitted || form.controls['shift_start_time'].touched)
        ) {
        <control-message
          message="This field is required."
        ></control-message>
      }
    </div>
    <div class="form-group col-sm-6 col-xs-12">
      <label for="shift_end_time">Shift End Time*</label>
      <!-- <input
      type="text"
      class="form-control"
      formControlName="shift_end_time"
      placeholder="00:00:00"
      /> -->
      <timepicker formControlName="shift_end_time" [showMeridian]="false"></timepicker>
      <!-- <input type="text" placeholder="24hr format" class="form-control" aria-label="24hr format" [ngxTimepicker]="fullTime" [format]="24"  readonly> -->
      <!-- <ngx-material-timepicker #fullTime></ngx-material-timepicker> -->
      @if (
        form.controls['shift_end_time'].hasError('required') &&
        (isSubmitted || form.controls['shift_end_time'].touched)
        ) {
        <control-message
          message="This field is required."
        ></control-message>
      }
    </div>
  </div>
  <!-- /.box-body -->

  <div class="box-footer">
    <button
      type="submit"
      (click)="submitForm()"
      class="btn btn-info pull-right"
      >
      Submit
    </button>
  </div>
</form>
</div>
